import { Grid, Skeleton, Typography } from "@mui/material";
import { fieldHeader } from "../../../../../components/fields/field_header";

const ViewShopperEngagementSkeleton = () => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          SHOPPER ENGAGEMENT:
          <Typography variant="body2">
            <Typography variant="body2">
              Please check the programs that you currently have in your store:
            </Typography>
          </Typography>
        </Typography>
      </Grid>

      {/* Website Developer */}
      <Grid item xs={12}>
        <Skeleton
          variant="rectangular"
          width="24px"
          height="24px"
          style={{ display: "inline-block", marginRight: 8 }}
        />
        <Skeleton
          variant="text"
          width="auto"
          height={24}
          style={{ display: "inline-block" }}
        />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="text" width="100%" />
      </Grid>

      {/* Ecommerce Store Pickup */}
      <Grid item xs={12}>
        <Skeleton
          variant="rectangular"
          width="24px"
          height="24px"
          style={{ display: "inline-block", marginRight: 8 }}
        />
        <Skeleton
          variant="text"
          width="auto"
          height={24}
          style={{ display: "inline-block" }}
        />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="text" width="100%" />
      </Grid>

      {/* Ecommerce Delivery */}
      <Grid item xs={12}>
        <Skeleton
          variant="rectangular"
          width="24px"
          height="24px"
          style={{ display: "inline-block", marginRight: 8 }}
        />
        <Skeleton
          variant="text"
          width="auto"
          height={24}
          style={{ display: "inline-block" }}
        />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="text" width="100%" />
      </Grid>

      {/* Loyalty Program */}
      <Grid item xs={12}>
        <Skeleton
          variant="rectangular"
          width="24px"
          height="24px"
          style={{ display: "inline-block", marginRight: 8 }}
        />
        <Skeleton
          variant="text"
          width="auto"
          height={24}
          style={{ display: "inline-block" }}
        />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="text" width="100%" />
      </Grid>

      {/* Social Media */}
      <Grid item xs={12}>
        <Skeleton
          variant="rectangular"
          width="24px"
          height="24px"
          style={{ display: "inline-block", marginRight: 8 }}
        />
        <Skeleton
          variant="text"
          width="auto"
          height={24}
          style={{ display: "inline-block" }}
        />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="text" width="100%" />
      </Grid>

      {/* Coca-Cola Bottler */}
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Coca-Cola Bottler", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
    </>
  );
};

export default ViewShopperEngagementSkeleton;
